import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, HostListener, ViewChildren} from '@angular/core';
import {FaqsService} from "../faqs/faqs.service";
import {first} from "rxjs";
import { Meta, Title } from '@angular/platform-browser';
import {SeoTagsService} from 'src/app/core/services/seo-tags.service';
@Component({
  selector: 'app-by-tdm',
  templateUrl: './by-tdm.component.html',
  styleUrls: [
    '../about-us/about-us.component.scss',
    './by-tdm.component.scss'
  ]
})

export class ByTdmComponent implements OnInit, AfterViewInit, OnDestroy {
  faqs: any = [];
  outlookBookingUrl = 'https://outlook.office.com/book/RservezunchangeaveclefondateurdelasolutionByTDM@tdm.immo/?ismsaljsauthenabled';
  temoignages = [
    {
      avatar: 'assets/resources/web/images/data/Olivier.png',
      nom: 'Olivier DEVILLIERS',
      region: 'Manager d’équipe ',
      texte: "Avant, je jonglais entre plusieurs logiciels, des tableaux Excel et des relances manuelles. Aujourd'hui, avec Kwerkey, je gère tout au même endroit : estimation, mandat, offre, compromis, suivi et facturation. J'ai gagné un temps considérable."
    },
    {
      avatar: 'assets/resources/web/images/data/Lucille.png',
      nom: 'Lucille TAUZIEDE',
      region: 'Conseillère Immobilier',
      texte: "Ce que j'apprécie le plus, c'est la sécurisation des dossiers. Les parcours intégrés dans Kwerkey m'aident à ne rien oublier et à respecter les obligations réglementaires. Je travaille plus sereinement et mes clients le ressentent."
    },
    {
      avatar: 'assets/resources/web/images/data/Marc.png',
      nom: 'Marc SOUDY',
      region: 'Concessionnaire',
      texte: "De l'estimation jusqu'à l'acte authentique, tout est centralisé. Plus besoin de ressaisir les informations plusieurs fois. Kwerkey m'apporte un véritable gain de productivité et une visibilité complète sur mon activité."
    },
    {
      avatar: 'assets/resources/web/images/data/Myriam.png',
      nom: 'Myriam PINAULT',
      region: 'Directrice d\'agence',
      texte: "En tant que dirigeante, j'avais besoin d'une solution capable d'accompagner toute mon équipe avec des méthodes homogènes. Kwerkey nous permet de suivre chaque dossier, d'anticiper notre activité et de sécuriser nos process. C'est devenu un véritable outil de pilotage."
    },
    {
      avatar: 'assets/resources/web/images/data/Cyril.png',
      nom: 'Cyril GAYRARD',
      region: 'Conseiller Immobilier',
      texte: "Chaque semaine, je gagne plusieurs heures grâce à Kwerkey. Les informations sont saisies une seule fois et suivent automatiquement le dossier jusqu'à l'acte authentique. Je passe moins de temps derrière un écran et davantage sur le terrain."
    },
    {
      avatar: 'assets/resources/web/images/data/Alain.png',
      nom: 'Alain BECAUD',
      region: 'Conseiller Immobilier',
      texte: "Les obligations réglementaires deviennent de plus en plus exigeantes. Avec Kwerkey, les parcours sont déjà structurés pour intégrer les contrôles nécessaires. Je travaille avec davantage de sérénité et je sais que mes dossiers sont sécurisés."
    }
  ];
  temoignagesGroupes: any[][] = [];

  @ViewChildren('temoignageCard') temoignageCards!: QueryList<ElementRef<HTMLElement>>;

  temoignageCardHeight = 0;
  private resizeTimeout?: ReturnType<typeof setTimeout>;
  private readonly temoignagesDesktopBreakpoint = 992;

  ngAfterViewInit(): void {
    this.scheduleTemoignageCardsHeightUpdate();

    this.temoignageCards.changes.subscribe(() => {
      this.scheduleTemoignageCardsHeightUpdate();
    });
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    clearTimeout(this.resizeTimeout);

    this.resizeTimeout = setTimeout(() => {
      this.computeTemoignagesGroupes();
      this.scheduleTemoignageCardsHeightUpdate();
    }, 150);
  }

  scheduleTemoignageCardsHeightUpdate(): void {
    setTimeout(() => this.updateTemoignageCardsHeight());
  }

  private updateTemoignageCardsHeight(): void {
    const cards = this.temoignageCards?.toArray().map(card => card.nativeElement) ?? [];

    if (!cards.length) {
      return;
    }

    const previousHeight = this.temoignageCardHeight;
    const visibleCard = cards.find(card => card.getBoundingClientRect().width > 0);
    const cardWidth = visibleCard?.getBoundingClientRect().width;

    if (!cardWidth) {
      this.temoignageCardHeight = previousHeight;
      return;
    }

    const measuringContainer = document.createElement('div');
    const pageWrapper = document.createElement('div');
    const blocWrapper = document.createElement('div');

    measuringContainer.style.position = 'fixed';
    measuringContainer.style.left = '-10000px';
    measuringContainer.style.top = '0';
    measuringContainer.style.visibility = 'hidden';
    measuringContainer.style.pointerEvents = 'none';
    measuringContainer.style.width = `${cardWidth}px`;

    pageWrapper.className = 'about-us-page';
    blocWrapper.className = 'temoignages-bloc';
    pageWrapper.appendChild(blocWrapper);
    measuringContainer.appendChild(pageWrapper);

    document.body.appendChild(measuringContainer);

    const maxHeight = Math.max(...cards.map(card => {
      const clonedCard = card.cloneNode(true) as HTMLElement;
      clonedCard.style.height = 'auto';
      clonedCard.style.minHeight = '0';
      clonedCard.style.width = `${cardWidth}px`;

      blocWrapper.appendChild(clonedCard);
      const height = Math.max(clonedCard.scrollHeight, clonedCard.getBoundingClientRect().height);
      blocWrapper.removeChild(clonedCard);

      return height;
    }));

    document.body.removeChild(measuringContainer);

    this.temoignageCardHeight = maxHeight ? Math.ceil(maxHeight) + 8 : previousHeight;
  }

  constructor(
    private faqService: FaqsService,
    private _meta: Meta,
    private title: Title,
    private _seoTags: SeoTagsService
  ) {
    this.computeTemoignagesGroupes();
  }

  private computeTemoignagesGroupes() {
    const taille = (typeof window !== 'undefined' && window.innerWidth < this.temoignagesDesktopBreakpoint) ? 1 : 3;
    const groupes: any[][] = [];
    for (let i = 0; i < this.temoignages.length; i += taille) {
      groupes.push(this.temoignages.slice(i, i + taille));
    }
    this.temoignagesGroupes = groupes;
  }
  ngOnInit() {
    this.faqService
      .getFaqBytdm()
      .pipe(first())
      .subscribe((response: any) => {

        if (response?.faq) {
          this.faqs = response.faq.map((faq: any) => {
            const cleaned = typeof faq.reponse === 'string'
              ? faq.reponse.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '').replace(/\son\w+="[^"]*"/gi, '')
              : faq.reponse;
            return {
              ...faq,
              reponse: cleaned
            };
          });
        }

        this.appliqueBalisesSeo(response?.seo);
      });
  }

  /**
   * Balises du <head> de la page : titre, description, partage social, URL
   * canonique et données structurées JSON-LD.
   *
   * Tout vient de la clé « seo » de l'API, calculée par le back
   * (App\Service\Seo\ByTdmSeo) — le même service qui alimente la version HTML
   * rendue aux robots qui n'exécutent pas JavaScript. Les deux versions de la
   * page annoncent donc forcément le même titre.
   *
   * Sans ça, la page était indexée sous le titre générique d'index.html
   * (« The door man ») et sans URL canonique.
   */
  private appliqueBalisesSeo(seo: any) {
    if (!seo?.title) {
      // Le front et le back se déploient séparément : mieux vaut ne rien poser
      // que d'inventer ici un titre qui contredirait celui du back.
      return;
    }

    this.title.setTitle(seo.title);
    this._meta.updateTag({name: 'description', content: seo.description});
    this._meta.updateTag({property: 'og:title', content: seo.title});
    this._meta.updateTag({property: 'og:description', content: seo.description});
    this._meta.updateTag({property: 'og:url', content: seo.canonical});

    this._seoTags.setCanonical(seo.canonical);
    this._seoTags.setJsonLd(seo.jsonld);
  }

  ngOnDestroy() {
    // Sans ça, le JSON-LD et le canonical de cette page resteraient dans le
    // document pendant la navigation vers la suivante.
    this._seoTags.clear();
  }

  convertIdForAncre(text: any) {
    return text.split(' ').join('-').toLowerCase();
  }
}
